export default __webpack_public_path__ + "static/media/i_home.249543e4.svg";